const transformClusters = (clusters) => {
    const transformed = {};
    for (const [clusterKey, clusterData] of Object.entries(clusters)) {
        // Ensure clusterKey and clusterData have the correct types
        const typedClusterKey = clusterKey;
        const typedClusterData = clusterData;
        transformed[typedClusterKey] = {
            subclusters: typedClusterData.subclusters.map(subcluster => ({
                ...subcluster,
                parent_key: typedClusterKey,
            })),
        };
    }
    return transformed;
};

export { transformClusters };
